import { SerpStoreOpenSnapshot } from '@/components/Approval/@components/SerpStoreOpen';
import { parseSerpContent } from '@/utils/approval/serpDocument';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 161 SERP 매장 개점 — 저장 content 그대로(레거시 조회와 동일) */
const SerpStoreOpenSlot = ({ data }: ContentExtraProps) => {
  const content = parseSerpContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <SerpStoreOpenSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default SerpStoreOpenSlot;
